import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteBrand } from "../../api/apiBrands";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف علامة تجارية
 */
export function useDeleteBrand() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteBrandMutate,
        isPending: isDeleting
    } = useMutation({
        mutationFn: deleteBrand,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["brands"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete brand");
        },
    });

    return { deleteBrandMutate, isDeleting };
}
